import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { LocalStorage } from '~/services/storage';
import { getQueryValue } from '../utils/get-query-value';

export enum LockedFeatureKey {
    APPLE_PAY = 'cf4d4ffe52cb6057e292de19fef54aba',
}

export const useLockedFeature = (featureKey: LockedFeatureKey) => {
    const storage = new LocalStorage();

    const { query } = useRouter();
    const [isEnabled, setIsEnabled] = useState(() => storage.get(`feat_${featureKey}`) === '1');

    useEffect(() => {
        const feat = getQueryValue(query.feat);

        if (feat === featureKey) {
            setIsEnabled(true);

            storage.set(`feat_${featureKey}`, '1');
        }
    }, []);

    return {
        isUnlocked: isEnabled,
        isLocked: !isEnabled,
    };
};
